import ActionType from './ActionType'
import { update } from './data'
import { contactFieldsWithoutColorsSelector } from 'selectors'
import { updateContact } from 'actions/contacts'

export const toggleDialog = (payload) => (dispatch) =>
	dispatch({ type: ActionType.RoundRobin.TOGGLE_DIALOG, payload })

export const selectUserToAdd = (payload) => (dispatch) =>
	dispatch({ type: ActionType.RoundRobin.SELECT_USER_TO_ADD, payload })

export const updateAssignmentPoolUsers =
	({ id, users }) =>
	(dispatch, getState) => {
		const entity = getState().data?.['account/ap']?.[id] || {}
		const newEntity = {
			...entity,
			pool: { ...(entity?.pool || {}), users, lastassigneduser: undefined },
		}

		return dispatch(update(newEntity, 'account/ap', null, 'account/ap/apId'))
	}

export const toggleAssigningIndividualContacts = (payload) => (dispatch) =>
	dispatch({
		type: ActionType.RoundRobin.TOGGLE_ASSIGNING_INDIVIDUAL_CONTACTS,
		payload,
	})

export const updateContactWithUser =
	(vastuser, contactID) => (dispatch, getState) => {
		const selector = contactID
			? getState().contacts.contactsWithEmailsByID?.[contactID]
			: contactFieldsWithoutColorsSelector(getState())
		dispatch({ type: ActionType.RoundRobin.UPDATE_CONTACT_WITH_USER })
		return dispatch(updateContact({ ...selector, vastuser }))
	}

// function to show specific contacts based on user assignment
